var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDsIconDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 164,
    viewBox: "0 0 232 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.395 0H5.60501C2.50945 0 0 2.41729 0 5.39916V158.601C0 161.583 2.50945 164 5.60501 164H226.395C229.491 164 232 161.583 232 158.601V5.39916C232 2.41729 229.491 0 226.395 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.1748V5.39647C-9.11687e-08 4.68757 0.144997 3.98562 0.426709 3.33071C0.708421 2.67581 1.12133 2.08078 1.64184 1.57964C2.16235 1.0785 2.78026 0.681053 3.46027 0.410013C4.14029 0.138974 4.86908 -0.000352194 5.60501 6.68579e-07H226.395C227.131 -0.000352194 227.86 0.138974 228.54 0.410013C229.22 0.681053 229.838 1.0785 230.358 1.57964C230.879 2.08078 231.292 2.67581 231.573 3.33071C231.855 3.98562 232 4.68757 232 5.39647V14.1748H0Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.166 163.997V129.002C29.166 129.002 30.7471 125.596 32.6991 125.596H98.3558C99.2931 125.597 100.192 125.956 100.854 126.595C101.517 127.233 101.889 128.099 101.889 129.002V163.997H29.166Z",
    fill: "#F2EAE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.462 122.335H121.293V41.7505H203.277V109.441",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8047 54.5044H75.2505",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8047 70.8096H77.0463",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1641 54.5044H97.7131",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66211 13.8149C4.66211 13.8149 213.868 14.6931 218.888 14.3359",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9318 9.58936C11.3687 9.58936 12.5335 8.46733 12.5335 7.08325C12.5335 5.69917 11.3687 4.57715 9.9318 4.57715C8.49491 4.57715 7.33008 5.69917 7.33008 7.08325C7.33008 8.46733 8.49491 9.58936 9.9318 9.58936Z",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5783 9.58936C20.0152 9.58936 21.18 8.46733 21.18 7.08325C21.18 5.69917 20.0152 4.57715 18.5783 4.57715C17.1414 4.57715 15.9766 5.69917 15.9766 7.08325C15.9766 8.46733 17.1414 9.58936 18.5783 9.58936Z",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2992 20.7827H14.1225C13.3494 20.7827 12.7227 21.3864 12.7227 22.1311V28.387C12.7227 29.1317 13.3494 29.7354 14.1225 29.7354H43.2992C44.0724 29.7354 44.6991 29.1317 44.6991 28.387V22.1311C44.6991 21.3864 44.0724 20.7827 43.2992 20.7827Z",
    fill: "#3098F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7646 97.0342H33.6451C32.6395 97.0342 31.8242 97.8195 31.8242 98.7883V109.775C31.8242 110.743 32.6395 111.529 33.6451 111.529H81.7646C82.7702 111.529 83.5855 110.743 83.5855 109.775V98.7883C83.5855 97.8195 82.7702 97.0342 81.7646 97.0342Z",
    fill: "#FE6571"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.627 100.964L80.6732 104.591L76.627 107.887",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M172.137 24.3633H183.941",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M189.236 24.3633H201.04",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M206.34 24.3633H218.147",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.75 162.053C53.2614 158.349 55.8854 153.863 57.606 151.169C62.6254 143.379 69.3793 134.442 74.2453 136.349C80.7511 138.901 73.0016 149.339 76.7076 151.48C80.659 153.764 84.8893 146.602 87.7699 146.825C93.9577 147.306 89.9087 160.586 89.0247 162.896",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M189.61 71.3682L183.595 66.6783C184.042 66.146 184.376 65.534 184.578 64.8774C184.78 64.2207 184.845 63.5322 184.771 62.8511C184.697 62.1701 184.484 61.5098 184.144 60.908C183.805 60.3063 183.346 59.7748 182.793 59.3439C182.241 58.913 181.605 58.5912 180.924 58.3968C180.242 58.2024 179.527 58.1393 178.82 58.211C178.113 58.2827 177.428 58.4879 176.803 58.8148C176.178 59.1416 175.626 59.5839 175.179 60.1161L169.164 55.4236C171.37 52.8433 174.544 51.2069 177.996 50.8709C181.448 50.5348 184.899 51.5263 187.596 53.6294C190.292 55.7325 192.017 58.7768 192.394 62.0993C192.772 65.4218 191.771 68.7533 189.61 71.3682Z",
    fill: "#FFCC00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.797 93.3892C159.696 93.3892 168.532 84.8782 168.532 74.3794C168.532 63.8806 159.696 55.3696 148.797 55.3696C137.898 55.3696 129.062 63.8806 129.062 74.3794C129.062 84.8782 137.898 93.3892 148.797 93.3892Z",
    fill: "#3098F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsIconDesktop);
export default __webpack_public_path__ + "static/media/ds-icon-desktop.6ecf5f98240bee438955896332d9ea1f.svg";
export { ForwardRef as ReactComponent };